import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationServices } from '@/services/apis';

const initialState = {
  applications: [],
  tot_count: 0,
  loading: true,
  error: false,
  errorMessage: '',
  status: 'idle',
  loggedUser: {},
  loggedUserOrganisations: []
};

export const fetchAllApplications = createAsyncThunk(
  'applications/fetchAllApplications',
  async ({ page, rowsPerPage, domainName, organizationName, applicationType, applicationName, applicationId }: any) => {
    const response = await ApplicationServices.fetchApplications(
      page,
      rowsPerPage,
      domainName,
      organizationName,
      applicationType,
      applicationName,
      applicationId
    );
    return response;
  }
);

export const createNewApplication = createAsyncThunk('application/createNewApplication', async (body: any, thunkAPI) => {
  const response = await ApplicationServices.createApplication(body);
  return response;
});

export const updateApllication = createAsyncThunk('application/updateApplication', async (userData: any) => {
  const { appId, ...finalData } = userData;
  const data = await ApplicationServices.updateApplication(finalData, appId);
  return data;
});

export const deleteApplication = createAsyncThunk('application/deleteApplication', async (data: any) => {
  const response = await ApplicationServices.deleteApplication(data);
  return response;
});

export const mappingApplication = createAsyncThunk('application/mappingApplication', async (data: any) => {
  try {
    const response = await ApplicationServices.mappingApplication(data);
    return response;
  } catch (err) {
    console.log(err);
  }
});

export const clientApplication = createAsyncThunk('application/clientData', async (data: any) => {
  try {
    const response = await ApplicationServices.getClientId(data);
    return response;
  } catch (err) {
    console.log(err);
  }
});

export const TokenApplication = createAsyncThunk('application/token', async (data: any) => {
  try {
    const response = await ApplicationServices.getToken(data);
    return response;
  } catch (err) {
    console.log(err);
  }
});

export const downloadApplications = createAsyncThunk('application/downloadApplication', async () => {
  const response = await ApplicationServices.downloadApplications();
  return response;
});

export const getApplicationApis = createAsyncThunk(
  'applications/fetchApis',
  async ({ domainName, organizationName, applicationType, applicationName, apiStatus, pageSize, pageNumber }: any) => {
    const response = await ApplicationServices.getApis({
      domainName,
      organizationName,
      applicationName,
      applicationType,
      apiStatus,
      pageSize,
      pageNumber
    });
    return response;
  }
);

export const subscribeApi = createAsyncThunk('application/subscribeAPI', async (body: any) => {
  const { action, ...finalData } = body;
  const data = await ApplicationServices.subscriptionApi(finalData, action);
  return data;
});

export const ApplicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAllApplications.pending, (state) => {});
    builder.addCase(fetchAllApplications.fulfilled, (state, { payload }) => {
      return { ...state, applications: payload?.result?.applications, tot_count: payload?.totalRecords, loading: false };
    });
    builder.addCase(fetchAllApplications.rejected, (state) => {
      return { ...state, applications: [], tot_count: 0, loading: false };
    });
  }
});

export const userSelector = (state: any) => state.application;

export default ApplicationSlice.reducer;
